export default __webpack_public_path__ + "static/media/stock-out.424a00bd.svg";